module.exports = __webpack_public_path__ + "static/media/sv.cce567b2.svg";